export default {
	additionalSpec: 'Additional spec',
	empty: { title: 'No vehicle features provided by seller' },
	list: {
		heatedSeats: 'Heated seats',
		panoramicRoof: 'Panoramic roof',
		parkingCamera: 'Parking camera',
		satNav: 'Sat nav',
		upgradedSoundSystem: 'Upgraded sound system',
		viewAll: 'View all ({count})',
	},
	modal: {
		costBreakdownTitle: 'All features ',
		title: 'Features',
	},
	retailValue: {
		description: 'Total value of factory fitted options when the vehicle was first retailed (source: HPI Spec Check).',
		title: 'Estimated value',
	},
	title: 'Features',
};
